import React, { useState, useEffect } from "react";
import { Snackbar, Button, Slide } from "@mui/material";

function CookieConsent() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const consentGiven = localStorage.getItem("cookiesAccepted");
    if (!consentGiven) {
      setOpen(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookiesAccepted", "true");
    setOpen(false);
  };

  return (
    open && <Snackbar
      open={open}
      TransitionComponent={(props) => <Slide {...props} direction="up" />}
      message="Usamos cookies para melhorar sua experiência no site. Ao continuar, você concorda com o uso de cookies."
      action={
        <Button
          color="primary"
          variant="contained"
          size="small"
          onClick={handleAccept}
        >
          Aceitar
        </Button>
      }
      sx={{ zIndex: 9999999999 }}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    />
  );
}

export default CookieConsent;
